// AssignmentsApi.js
import axiosInstance from "../Services/Api/axiosInstance";

export const fetchAssignments = async () => {
    try {
        const response = await axiosInstance.get("/tasks");
        return response.data.user_tasks;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error fetching assignments");
    }
};

export const fetchAssignmentDetails = async (assignmentId) => {
    try {
        const response = await axiosInstance.get(`/tasks/${assignmentId}`);
        const data = response.data;

        // Extract task_details array and flatten it
        if (data.task_details && Array.isArray(data.task_details)) {
            return {
                ...data,
                task_details: data.task_details[0] || {}, // Extract first item from array
                Subject: data.task_details[0]?.Subject || '',
                taskFields: data.taskFields || [],
                label: data.label || ''
            };
        }

        return data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error fetching assignment details");
    }
};

export const updateAssignmentStatus = async (assignmentId, currentStatus) => {
    try {
        const body = {
            newStatus: currentStatus === "Completed" ? "Not Started" : "Completed"
        };

        const response = await axiosInstance.put(`/tasks/${assignmentId}`, body);
        const data = response.data.task_details;

        // Handle if API returns array
        return Array.isArray(data) ? data[0] : data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error updating assignment status");
    }
};



export const updateDescription = async (assignmentId, newDescription) => {
    try {
        const response = await axiosInstance.put(`/tasks/desc/${assignmentId}?updateField=${"desc"}`, {
            newDescription: newDescription
        });
        const data = response.data.task_details;

        // Handle if API returns array
        return Array.isArray(data) ? data[0] : data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error updating assignment status");
    }
};
